import React from 'react';
import {Outlet} from "react-router-dom";

import css from './DishesPage.module.css';
import {TitleMenuDishes} from "../../components/dishesSection/TitleMenuDishes/TitleMenuDishes";


const DishesPage = () => {
    return (
        <section className={css.wrap}>
            <section className={css.menuBlock}>
                <TitleMenuDishes/>
            </section>

            <section className={css.outletBlock}>
                <Outlet/>
            </section>
        </section>
    );
};

export {DishesPage};